import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { ORGANISATION_ROLES_RESOURCE, CREATE_ORGANISATION_ROLE_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const CreateOrganisationRoleService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_ORGANISATION_ROLE_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.organisationRoles(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: ORGANISATION_ROLES_RESOURCE,
            listPath: 'organisationRoles',
            valuesModifier: values => ({ ...body, id: values.id }),
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createOrganisationRoleFailed'),
            onSuccessMessage: t('createOrganisationRoleSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateOrganisationRoleService;
